import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SeriesThreePlusComplete.module.scss';
import Button from '../../components/Button';
import { seriesThreePlusUpgrade } from '../../lib/analytics/events';

export default function SeriesThreePlusComplete() {
  const { t } = useTranslation();
  useEffect(() => seriesThreePlusUpgrade.successfullyUpgradedToSeriesThreePlus(), []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className={styles.simpleFullWidthWrapper}>
      <div className={styles.simpleContainer}>
        <div className={styles.simpleSpacer} />
        <div className={styles.simpleHeaderContainer}>
          <h1 className={styles.simpleHeader}>{t('thank_you')}</h1>
          <p className={styles.simpleSubheader}>{t('youve_successfully_upgraded_to_series_3_plus')}</p>
        </div>
        <Button
          className={styles.simpleButton}
          onClick={() => {
            window.open('fi://closeappview');
          }}
        >
          {t('done')}
        </Button>
      </div>
    </div>
  );
}
